import { MutationError } from '@funtech-int/kp-graphql-sdk/yango-movies-www';
import { AnalyticsSender } from '@funtech-int/yango-shared';

import { ErrorType } from '@kinopoisk-int/evgen-web-events/web/named_enums';
import {
    settingsLanguageSelectionChanged,
    settingsLanguageSelectionErrorRaised,
    settingsLanguageSelectionNavigated,
    SettingsLanguageSelectionNavigatedSource,
    settingsLanguageSelectionSelected,
    settingsLanguageSelectionShowed,
} from '@kinopoisk-int/evgen-web-events/web/settings';

type LanguageParams = {
    newValue: string;
    oldValue?: string;
};

export const createSettingsLanguageAnalyticsEvents = (eventSender: AnalyticsSender) => ({
    showed(currentLanguage: string | undefined) {
        eventSender.sendOnce(settingsLanguageSelectionShowed, {
            value: currentLanguage,
        });
    },

    selected({ newValue, oldValue }: LanguageParams) {
        eventSender.send(settingsLanguageSelectionSelected, {
            newValue,
            oldValue,
        });
    },

    navigated(currentLanguage: string | undefined) {
        eventSender.send(settingsLanguageSelectionNavigated, {
            value: currentLanguage,
            source: SettingsLanguageSelectionNavigatedSource.Settings,
        });
    },

    changed({ newValue, oldValue }: LanguageParams) {
        eventSender.send(settingsLanguageSelectionChanged, {
            newValue,
            oldValue,
        });
    },

    errorRaised(error: unknown) {
        const errorMessage = (error as any)?.message || '';
        const errorTitle =
            error instanceof MutationError
                ? (error as any)?.__typename || ''
                : (error as any)?.name || '';

        const errorType =
            error instanceof MutationError ? ErrorType.BackendError : ErrorType.NetworkError;

        eventSender.send(settingsLanguageSelectionErrorRaised, {
            requestId: '',
            errorMessage,
            errorTitle,
            errorType,
        });
    },
});
